<template>
  <div class="thank-you">
    <div class="lead t-lead-l" v-text="t('newsletter.thanks.title')" />
    <div class="t-p-m-160" v-html="nbsp(thanks)" />
  </div>
</template>

<script lang="ts" setup>
const { t } = useI18n()

defineProps<{
  thanks: string
}>()
</script>

<style lang="scss" scoped>
.thank-you {
  @include center-content;
  flex-direction: column;
  text-align: center;
}

.lead {
  margin-bottom: rem(24px);
}
</style>
